export default "__VITE_ASSET__BlBFqQWe__"